import {animate, animateChild, group, query, style, transition, trigger} from '@angular/animations';

// export const view360RouteAnimation =
//  trigger('routeAnimations', [
//    transition('* => isLeft', slideTo('left') ),
//    transition('* => isRight', slideTo('right') ),
//    transition('isRight => *', slideTo('left') ),
//    transition('isLeft => *', slideTo('right') )
//  ]);
//
// export function slideTo(direction) {
//  const optional = { optional: true };
//  return [
//    style({ position: 'relative', 'overflow': 'hidden'  }),
//    query(':enter, :leave', [
//      style({
//        position: 'absolute',
//        top: 0,
//        [direction]: 0,
//        width: '100%',
//        opacity: 1,
//      })
//    ], optional),
//    query(':enter', [
//      style({ [direction]: '-100%'})
//    ]),
//    group([
//      query(':leave', [
//        animate('600ms ease',
//          style({
//            [direction]: '100%',
//            opacity: 0
//          })
//        )
//      ], optional),
//      query(':enter', [
//        animate('600ms ease',
//          style({
//            [direction]: '0%'
//          })
//        )
//      ])
//    ]),
//  ];
// }

export const view360RouteAnimation = trigger('routeAnimations', [
  transition('* => *', [
    style({position: 'relative', overflow: 'hidden'}),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          'min-height': '100%',
        }),
      ],
      {optional: true},
    ),
    query(
      ':enter',
      [
        style({
          transform: 'translateX(100%)',
          'box-shadow': '0 0 0 0 rgba(0,0,0,0)',
          'z-index': '80',
        }),
      ],
      {optional: true},
    ),
    query(':leave', animateChild(), {optional: true}),
    group([
      query(
        ':enter',
        [
          animate(
            '1s cubic-bezier(0.86, 0, 0.07, 1)',
            style({
              transform: 'translateX(0)',
              'box-shadow': '0 0 100px 0 rgba(0,0,0,0.5)',
            }),
          ),
        ],
        {optional: true},
      ),
      query(
        ':leave',
        [
          animate(
            '1s cubic-bezier(.16,.78,.26,.99)',
            style({
              transform: 'scale(0.85)',
              opacity: '0.3',
            }),
          ),
        ],
        {optional: true},
      ),
    ]),
    query(':enter', animateChild(), {optional: true}),
  ]),
]);
